import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LojistikFiyatArsiv } from 'src/model/lojistik-fiyat-arsiv';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-fiyat-arsiv-olustur',
  templateUrl: './lojistik-fiyat-arsiv-olustur.component.html',
  styleUrls: ['./lojistik-fiyat-arsiv-olustur.component.css']
})
export class LojistikFiyatArsivOlusturComponent implements OnInit {

  private subscriptions: Subscription[] = [];
  id: string = null;
  lojistikFiyat: LojistikFiyatArsiv = null;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private restService: RestService) { }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      if (this.id !== '0') {
        this.getLojistikFiyat();
      } else {
        this.lojistikFiyat = new LojistikFiyatArsiv();
        this.lojistikFiyat.tarih = null;
        this.lojistikFiyat.fiyat = null;
      }
    }));
  }

  getLojistikFiyat() {
    this.restService.getLojistikFiyat(this.id).subscribe(res => {
      if (res) {
        this.lojistikFiyat = res;
        console.log(res)
      }
    });
  }

  save() {
    this.restService.lojistikFiyatKaydet(this.lojistikFiyat).subscribe(res => {
      this.router.navigate(['lojistik-fiyat-arsivler']);
    })
  }
}
